// extracted by mini-css-extract-plugin
export default {"root":"LessonIcon-modules__root__wUMnl","videoIcon":"LessonIcon-modules__videoIcon__Sf2XM"};